import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { UserCompany } from '../models/company.class';
import { DebugLoggerService } from '../services/debug-logger.service';

@Injectable({
  providedIn: 'root'
})
export class CompanyProperty {

  private _debugLogger = inject(DebugLoggerService);

  private _companyApps: BehaviorSubject<UserCompany> = new BehaviorSubject<any>(null);
  public companyApps: Observable<UserCompany> = this._companyApps.asObservable();

  constructor() { }

  public setCompanyApps(companyApps: any): void {
    this._companyApps.next(companyApps);
    this._debugLogger.logState('CompanyProperty', 'companyApps', companyApps);
  }
  public get userCompanyApps(): any {
    return this._companyApps.getValue();
  }
}
